import CreacionContratoView from './CreacionContratoView.vue'
import VistaContratoView from './VistaContratoView.vue'
import EdicionContratoView from './EdicionContratoView.vue'

export default [
  {
    path: 'nuevo',
    component: CreacionContratoView
  },
  {
    path: 'edicion/:id',
    component: EdicionContratoView
  },
  {
    path: 'vista/:id',
    component: VistaContratoView
  }
];